import { AppShell } from '@/components/shell/AppShell'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext } from '@tanstack/react-router'
import { z } from 'zod'

// `sala` carries a chat-driven view intent (CDV-002) as a JSON string.
// Living on the root schema means every route inherits it, so the sala
// can mount on top of any page without touching each route's own
// validateSearch.
const rootSearchSchema = z.object({
  sala: z.string().optional().catch(undefined),
  // 15 Oct 2026: chat evidence photos, shown in a side panel over the page.
  evidence: z.string().optional().catch(undefined),
})

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  validateSearch: rootSearchSchema,
  component: AppShell,
})
